/* Full-width Stiletto-style navigation, using Impulse's drawer/cart/search lifecycle. */
(function () {
  'use strict';
  function menu() { return document.querySelector('#NavDrawer[data-fm-menu-root]'); }
  function positionMenu(drawer) {
    var header = document.getElementById('SiteHeader');
    var top = header ? Math.max(0, header.getBoundingClientRect().top) : 0;
    drawer.style.setProperty('--fm-menu-top', top + 'px');
  }
  function showPanel(drawer, id, focusTarget) {
    var target = document.getElementById(id);
    if (!target || !drawer.contains(target)) return;
    drawer.querySelectorAll('[data-fm-menu-panel]').forEach(function (panel) {
      panel.hidden = panel !== target;
    });
    drawer.querySelectorAll('[data-fm-menu-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', String(button.dataset.fmMenuOpen === id));
    });
    target.scrollTop = 0;
    var focus = focusTarget || target.querySelector('button, a[href]');
    if (focus) focus.focus();
  }
  document.addEventListener('drawerOpen.NavDrawer', function () {
    var drawer = menu();
    if (!drawer) return;
    positionMenu(drawer);
    showPanel(drawer, drawer.dataset.fmMenuRoot, drawer.querySelector('.js-drawer-close'));
  });
  document.addEventListener('click', function (event) {
    var drawer = menu();
    if (!drawer || !drawer.contains(event.target)) return;
    var forward = event.target.closest('[data-fm-menu-open]');
    var back = event.target.closest('[data-fm-menu-back]');
    if (forward || back) {
      event.preventDefault();
      if (forward) showPanel(drawer, forward.dataset.fmMenuOpen);
      else {
        var current = back.closest('[data-fm-menu-panel]').id;
        var opener = Array.from(drawer.querySelectorAll('[data-fm-menu-open]')).find(function (button) {
          return button.dataset.fmMenuOpen === current;
        });
        showPanel(drawer, back.dataset.fmMenuBack, opener);
      }
    }
    // Close navigation before the existing cart/search click handlers run.
    if (event.target.closest('.js-search-header, .js-drawer-open-cart')) {
      if (theme.NavDrawer.activeSource) theme.NavDrawer.activeSource.setAttribute('aria-expanded', 'false');
      theme.NavDrawer.activeSource = null;
      theme.NavDrawer.close();
    }
  }, true);
  document.addEventListener('keydown', function (event) {
    var drawer = menu();
    if (!drawer || !drawer.classList.contains('drawer--is-open') || event.key !== 'Tab') return;
    var links = Array.from(drawer.querySelectorAll('button, a[href], [tabindex="0"]')).filter(function (el) {
      return el.offsetParent !== null && !el.disabled;
    });
    var first = links[0], last = links[links.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === drawer)) {
      event.preventDefault(); event.stopImmediatePropagation(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); event.stopImmediatePropagation(); first.focus();
    }
  }, true);
  window.addEventListener('resize', function () {
    var drawer = menu();
    if (drawer && drawer.classList.contains('drawer--is-open')) {
      if (window.innerWidth > 768) theme.NavDrawer.close();
      else positionMenu(drawer);
    }
  });
})();
